<div class="categoryTree">
    <div *ngFor="let category of list" class="rowCat">
        <div class="line"></div>
        <div class="cat">
            <div class="label">
                <span (click)="getSubs(category)">{{ category.label + ' (' + category.productCount + ' skus)' }}</span>
                <div class="actions size-icon">
                    <div class="d-flex  align-items-center">

                        <span *ngIf="category.categories && category.categories.length > 0" class="m-l-1 hide-subcategory-icon margin_top_left_ajust_1" (click)="getSubs(category)"></span>
                        <span *ngIf="!category.categories || category.categories.length < 1" class="m-l-1 show-subcategory-icon margin_top_left_ajust_1" (click)="getSubs(category)"></span>
                        <span class="m-l-1 edit-category-icon" (click)="editCategory(category)"></span>
                        <span class="m-l-1 delete-category-icon" (click)="eliminar(category)"></span>
                        <span class="m-l-1 custom_search margin_top_left_ajust_1" (click)="goToProductsByCategory(category)"></span>
                    </div>
                    
                </div>
            </div>
            <app-category-tree [list]="category.categories" (addCategoryEvent)="addCategory($event)" (editCategoryEvent)="editCategory($event)"></app-category-tree>
        </div>
    </div>
</div>